export const FETCH_USER_MIPS = "FETCH_USER_MIPS";
export const FETCH_USER_MIPS_START = "FETCH_USER_MIPS_START";
export const FETCH_USER_MIPS_SUCCESS = "FETCH_USER_MIPS_SUCCESS";
export const FETCH_USER_MIPS_ERROR = "FETCH_USER_MIPS_ERROR";



export const fetchUserMips = () => {
    return {
        type: FETCH_USER_MIPS,
    };
};